export type App = 'confluence' | 'projects' | 'goals' | 'teams' | 'focus';

export const ALL_APPS: Exclude<App, 'focus'>[] = ['confluence', 'projects', 'goals', 'teams'];

export const ALL_APPS_WITH_FOCUS: App[] = [...ALL_APPS, 'focus'];

export const parseAppParam = (param?: string): Exclude<App, 'focus'>[] => {
	const list = (param ?? '').split(',');
	return list.filter((item) => ALL_APPS.includes(item as Exclude<App, 'focus'>)) as Exclude<
		App,
		'focus'
	>[];
};

/**
 * Temporary function as we transition to the platform component which supports Focus
 */
export const parseAppParam_platform = (param?: string): App[] => {
	const list = (param ?? '').split(',');
	return list.filter((item) => ALL_APPS_WITH_FOCUS.includes(item as App)) as App[];
};

export const encodeAppParam = (apps: App[]): string => {
	return apps.join(',');
};

export const APP_QUERY_PARAM = 'app';
